<template>
  <div class="account-balance-page">
    <ErrorView v-if="error"
               :code="error.code"
               :title="$tVacancy(error.message)"/>

    <template v-else>
      <div class="account-balance-page__head">
        <h1 class="account-balance-page__title">{{ $tAccount('Balance') }}</h1>

        <div class="account-balance-page__head-bar">
          <AccountBalanceInfo :label="$tAccount('All-time income')"
                              :value="totalIncome"
                              :pending="pending"
                              class="account-balance-page__head-bar-item"/>
          <AccountBalanceInfo :label="$tAccount('Current balance')"
                              :value="balance"
                              :pending="pending"
                              class="account-balance-page__head-bar-item _dark"/>
          <AccountBalanceInfo :label="$tAccount('Available for withdrawal')"
                              :value="balance"
                              withdraw
                              :pending="pending"
                              class="account-balance-page__head-bar-item"/>
        </div>
      </div>

      <div class="account-balance-page__tabs account-tabs _grey">
        <div class="account-tabs__navs d-sm-none">
          <AccountTabsNavs
              class="account-tabs__navs-inner"
              :tabs="tabs"
              :current="currentTab"
              @change="onTabClick"
          />
        </div>
        <AccountTabsNavsMob
            :tabs="tabs"
            :current="currentTab"
            @change="onTabClick"
        />
        <div class="account-tabs__content">
          <transition
              name="fade"
              mode="out-in"
          >
            <div v-if="currentTab === 0"
                 class="account-tabs__block"
                 :key="1">
              <AccountTabItemHistory :is-mob="isMob"
                                     :balance="balance"/>
            </div>

            <div v-if="currentTab === 1"
                 class="account-tabs__block"
                 :key="2">
              <AccountTabItemWithdraw :is-mob="isMob"
                                      :balance="balance"/>
            </div>
          </transition>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import ErrorView from '@/components/ErrorView'
  import AccountTabsNavs from '@/components/accountTabs/AccountTabsNavs'
  import AccountTabsNavsMob from '@/components/accountTabs/AccountTabsNavsMob'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import AccountTabItemHistory from '@/components/accountBalance/AccountTabItemHistory'
  import AccountTabItemWithdraw from '@/components/accountBalance/AccountTabItemWithdraw'
  import AccountBalanceInfo from '@/components/accountBalance/AccountBalanceInfo'

  const tabs = [
    {
      id: 1,
      slug: 'income',
      name: 'Receipt history'
    },
    {
      id: 2,
      slug: 'withdraw',
      name: 'Withdrawals'
    }
  ]

  export default {
    name: 'AccountBalancePage',
    components: {
      ErrorView,
      AccountBalanceInfo,
      AccountTabItemWithdraw,
      AccountTabItemHistory,
      AccountTabsNavsMob,
      AccountTabsNavs,

    },
    mixins: [windowSizeMixin],
    data() {
      return {
        pending: true,
        error: null,

        balance: null,
        totalIncome: null,
      };
    },
    computed: {
      isMob() {
        return this.windowSizeMixin.width < 1024
      },
      currentTab() {
        const slug = this.$route.params.tab
        if (!slug) return 0

        return this.tabs.findIndex(item => item.slug === slug)
      },
      tabs() {
        return tabs.map(item => {
          item.name = this.$tAccount(item.name)
          return item
        })
      }
    },
    methods: {
      load() {
        this.pending = true

        http.get('/api/cabinet/payments/balance').then(({data}) => {
          this.balance = +data.balance || 0
          this.totalIncome = +data.total_income || 0
        }).catch(error => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        })
      },
      onTabClick(index) {
        this.$router.push({params: {tab: this.tabs[index].slug}})
      }
    },
    created() {
      this.load()
    },
    beforeRouteEnter(to, from, next) {
      if (!to.params.tab) {
        return next({params: {tab: tabs[0].slug}})
      }

      next()
    }
  };
</script>
